import { render } from "./OuterHeader.vue?vue&type=template&id=3c4e1c15"
import script from "./OuterHeader.vue?vue&type=script&lang=js"
export * from "./OuterHeader.vue?vue&type=script&lang=js"

import "./OuterHeader.vue?vue&type=style&index=0&id=3c4e1c15&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__